import { SegmentableCheckoutCharacteristic } from "@redotech/redo-conversion-core-common/checkouts/checkout-tree";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export type StaticConditionCharacteristic =
  | SegmentableCheckoutCharacteristic.CROSS_BORDER_SHIPMENT
  | SegmentableCheckoutCharacteristic.PO_BOX_SHIPMENT
  | SegmentableCheckoutCharacteristic.LCG_ELIGIBLE_SHIPMENT;

export const StaticConditionInspectorContent = memo(
  function StaticConditionInspectorContent({
    characteristic,
  }: {
    characteristic: StaticConditionCharacteristic;
  }) {
    const { t } = useTranslation();
    const conditionText = (() => {
      switch (characteristic) {
        case SegmentableCheckoutCharacteristic.CROSS_BORDER_SHIPMENT:
          return t("Origin country differs from destination country");
        case SegmentableCheckoutCharacteristic.PO_BOX_SHIPMENT:
          return t("Shipping address is a PO box");
        case SegmentableCheckoutCharacteristic.LCG_ELIGIBLE_SHIPMENT:
          return t("Merchant can ship LCG/DDP to the destination country");
      }
    })();

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Condition")}
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {conditionText}
        </Text>
      </Flex>
    );
  },
);
